import axios from "axios";
import { getKeycloackToken } from "./auth";
import * as types from "../constants/collectionConstants";
import { getCookie, setCookie } from "../../common/cookie_helper";
import { notify } from "./snack";
let collectionSource = "";

export const createCollectionV2 = async (collection, dispatch) => {
  let _orgId = getCookie("org_id");
  var data = new FormData();

  data.append("collectionName", collection?.name);
  data.append("collectionDescription", collection?.collectionDescription);
  data.append("jsonFields", "");
  data.append("usertype", collection?.planType);
  data.append("base_language", collection?.baseLanguage||"en");
  data.append("model", collection?.model||"gpt-4o");
  data.append("source", collection?.source);
  data.append("response_language", collection?.response_language||"en");

  if(collection?.source != "files"){
    data.append("source_setting", collection?.source_setting);
    data.append("search_type", collection?.selectedLiveSearch);
    
    if (typeof collection?.urls === "string") {
      let urlArray = collection.urls.split(",");
      data.append("urls", JSON.stringify(urlArray)); 
    } else if (Array.isArray(collection?.urls)) {
      data.append("urls", JSON.stringify(collection.urls)); 
    }
  }
  let token = await getKeycloackToken();
  var config = {
    method: "post",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/CreateCollection`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
    data: data,
  };

  try {
    let status = await axios(config);
    return status;
  } catch (err) {
    console.log("Error while creating collection", err.message);
  }
};

export const getCollectionsV2 = async () => {
  let _orgId = getCookie("org_id");

  // _orgId = ('; '+document.cookie).split(`; org_id=`).pop().split(';')[0];

  console.log(_orgId);
  let token = await getKeycloackToken();
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/ListCollections`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    return data;
  } catch (err) {
    console.log("Error while retrieving", err.message);
  }
};

export const getListModels = async () => {
  let _orgId = getCookie("org_id");
  let token = await getKeycloackToken();

  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/ListModels`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    return data?.response;
  } catch (err) {
    console.log("Error while retrieving", err.message);
  }
};

export const queryDocumentV2 = async (
  question,
  collectionName,
  docName,
  chatContext,
  planType,
  imageFileData
) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("question", question);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", docName);
    data.append("chat_context", chatContext);
    data.append("usertype", planType);

    if (imageFileData?.length > 0) {
      imageFileData?.map((obj, ind) => {
        obj?.type?.includes("image")
          ? data.append("image", obj)
          : data.append("audio", obj);
      });
    }

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/QueryDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const getSqlQueryV2 = async (user_query, collectionName, planType) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("user_query", user_query);
    data.append("collection_name", collectionName);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/get-sql-query`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const getLiveSearchQuery = async (user_query, collectionName,planType) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("question", user_query);
    data.append("collectionName", collectionName);
    data.append("usertype", planType);
    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/LiveSearchAPI`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};





export const uploadTextV2 = async (
  collectionName,
  fileType,
  textValue,
  resourceName,
  usertype
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("fileType", fileType);
    data.append("document", textValue);
    data.append("jsonData", "");
    data.append("documentName", resourceName);
    data.append("usertype", usertype);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UploadDocument`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const updateTextV2 = async (
  collectionName,
  fileType,
  textValue,
  resourceName,
  usertype
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("fileType", fileType);
    data.append("document", textValue);
    data.append("jsonData", "");
    data.append("documentName", resourceName);
    data.append("usertype", usertype);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UpdateTextData`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadDocumentV2 = async (
  collectionName,
  file,
  planType,
  fileURL,
  ocrFlag
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("document", file);
    data.append("collectionName", collectionName);
    const fileNameWithExtension = file?.name;
    const fileName = fileNameWithExtension.substring(
      0,
      fileNameWithExtension.lastIndexOf(".")
    );

    data.append("jsonData", "");
    data.append("documentName", fileName); // Use the extracted filename without extension
    data.append("planType", planType);
    data.append("useOCR", ocrFlag);

    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/collection/UploadDocumentV2?fileURL=${fileURL}`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadDocumentV2AzureService = async (
  collectionName,
  file,
  planType,
  fileURL,
  ocrFlag
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("document", file);
    data.append("collectionName", collectionName);
    const fileNameWithExtension = file?.name;
    const fileName = fileNameWithExtension.substring(
      0,
      fileNameWithExtension.lastIndexOf(".")
    );

    data.append("jsonData", "");
    data.append("documentName", fileName); // Use the extracted filename without extension
    data.append("usertype", planType);
    if (fileURL?.length > 0) {
      data.append("fileUrl", fileURL);
    }

    var config = {
      url: `${process.env.REACT_APP_COLLECTION_FILE_UPLOAD_AZURE_URL}/api/v2/process_file`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadDocumentTranscribe = async (
  collectionName,
  file,
  planType,
  selectedOptions
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("file", file);
    data.append("tasks", selectedOptions);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/TranscribeAPI`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data?.response;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadFileURLTranscribe = async (
  collectionName,
  fileURL,
  planType,
  selectedOptions
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("file_url", fileURL);
    data.append("tasks", selectedOptions);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/TranscribeAPI`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data?.response;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadTextTranslate = async (
  collectionName,
  text,
  planType,
  selectedOptions
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("text_input", text);
    data.append("tasks", selectedOptions);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/TranscribeAPI`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data?.response;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const deleteCollectionV2 = async (collectionName, planType) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();

    data.append("collectionName", collectionName);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/DeleteCollection`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const exportCollectionV2 = async (collectionName, dateQuery) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    var config = {
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/collection/exportCollectionV2?id=${collectionName}${dateQuery}`,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const getChatHistoryV2 =
  (collectionName, userEmail) => async (dispatch) => {
    try {
      let _orgId = getCookie("org_id");
      let token = await getKeycloackToken();

      var config = {
        url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/GetQueryLog?collectionId=${collectionName}&userName=${userEmail}&fileType=json`,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-orgId": _orgId,
        },
      };

      let result = await axios(config);

      dispatch({
        type: types.GET_CHAT_HISTORY_DATA,
        chatHistoryData: result?.data,
      });
    } catch (e) {
      console.log("error", "Something went wrong");
    }
  };

export const getTrainedDataV2 = (collectionName) => async (dispatch) => {
  let _orgId = getCookie("org_id");

  let token = await getKeycloackToken();
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/GetupdateLog?collectionName=${collectionName}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-Orgid": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    dispatch({
      type: types.GET_TRAINED_DATA,
      trainedData: data.data,
    });
  } catch (err) {
    console.log("Error while retrieving", err.message);
  }
};

export const getWalkthroughs = (collectionName) => async (dispatch) => {
  let _orgId = getCookie("org_id");

  let token = await getKeycloackToken();

  let data = new FormData();

  data.append("partition_name", collectionName);

  var config = {
    method: "post",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/getwalkthrough_list`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-Orgid": _orgId,
    },
    data: data,
  };

  try {
    let { data } = await axios(config);
    dispatch({
      type: types.GET_WALKTHROUGHS_DATA,
      walkthroughsData: data.message?.walkthrough_list,
      instructionData: data.message?.additional_instruction,
      collectionSource: data.message?.source,
      collectionDocs: data.message?.document_names,
      systemPrompt: data.message?.system_prompt,
      preprocessingInstuctions: data.message?.preprocessing_instuctions,
    });
    return data;
  } catch (err) {
    console.log("Error while retrieving", err.message);
  }
};

export const updateWalkthroughs =
  (collectionName, walkthroughsPayload) => async (dispatch) => {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("partition_name", collectionName);
    data.append("walkthrough_list", JSON.stringify(walkthroughsPayload));

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/updatewalkthrough_list`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Orgid": _orgId,
      },
      data: data,
    };

    try {
      let result = await axios(config);
      return result;
    } catch (err) {
      console.log("Error while retrieving", err.message);
    }
  };

export const deleteTrainedDataV2 =
  (collectionName, questionId, question, planType) => async (dispatch) => {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("question", question);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("updated_question_id", questionId);
    data.append("usertype", planType);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/DeleteUpdateDocument`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "X-Orgid": _orgId,
      },
      data: data,
    };

    try {
      let { data } = await axios(config);
      dispatch({
        type: types.DELETE_TRAINED_DATA,
        trainedData: data.data,
      });
    } catch (err) {
      console.log("Error while retrieving", err.message);
    }
  };

export const sendInputAnswerV2 = async (
  collectionName,
  questionId,
  question,
  oldAnswer,
  newAnswer,
  planType
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("question_id", questionId);
    data.append("question", question);
    data.append("old_answer", oldAnswer);
    data.append("new_answer", newAnswer);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UpdateDocData`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const getDocUploadStatusV2 = async (
  docName,
  collectionName,
  planType
) => {
  let _orgId = getCookie("org_id");

  let token = await getKeycloackToken();
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/GetUploadStatus?document_name=${docName}&collectionId=${collectionName}&usertype=${planType}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
  };

  try {
    let { data } = await axios(config);
    return data?.response[0];
  } catch (err) {
    console.log("Error while retrieving", err.message);
    return { status: false, error: err.message };
  }
};

export const deleteDocumentV2 = async (collectionName, docName, planType) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", docName);
    data.append("usertype", planType);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/DeleteDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadUrlV2 = async (
  collectionName,
  url,
  resourceName,
  planType,
  valueScrape
) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("document", url);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", resourceName);
    data.append("fileUrl", url);
    data.append("usertype", planType);
    if (valueScrape == 2) {
      data.append("whole_website", true);
    }
    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UploadDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadInstructionV2 = async (collectionName, instruction) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("partition_name", collectionName);
    if (instruction?.length < 1) {
      instruction = " ";
    }
    data.append("user_instructions", instruction);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/update_user_instructions`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadSharepointData = async (
  collectionName,
  fileTypes,
  driveType,
  userType
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("files_info", fileTypes);
    data.append("drive_type", driveType);
    data.append("usertype", userType);
    data.append('jsonData','')
    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/DriveUpload`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadGoogleDriveDataV2 = async (
collectionName,
file,
blobName,
planType
) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    const fileNameWithExtension = blobName;
    const fileName = fileNameWithExtension.substring(
      0,
      fileNameWithExtension.lastIndexOf(".")
    );
    data.append("document", file,blobName);
    data.append("jsonData", "");
    data.append("documentName", fileName);
    data.append("usertype", planType);
    data.append("useOCR",'false')
    const fileExt = fileNameWithExtension.substring(fileNameWithExtension.lastIndexOf('.')+1)
    if (fileExt != 'xlsx' && fileExt != 'xls') {
      let result = await axios.post(`${process.env.REACT_APP_COLLECTION_FILE_UPLOAD_AZURE_URL}/api/v2/process_file`,data,{headers: {
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      }});
      return result;
    }
    let result = await axios.post(`${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UploadDocument`,data,{headers: {
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    }});
    
    return result;
  } catch (e) {
      console.log("error",e, "Something went wrong");
    }

};


export const uploadGoogleDriveData = async (collectionName,userType,filesData,accessToken,driveType) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("collectionName", collectionName);
    data.append("files_info", JSON.stringify(filesData));
    data.append("drive_type", driveType);
    data.append("usertype", userType);
    data.append('token',accessToken)
    data.append('jsonData','')

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/DriveUpload`,
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

// TTS
export const getAudio = (lang, text) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/collection/textToSpeech`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ lang, text }),
    };
    const result = await fetch(
      `${process.env.REACT_APP_BOT_SERVICE_URL}/collection/textToSpeech`,
      config
    );

    const audioBlob = await result.blob();

    const audioUrl = URL.createObjectURL(audioBlob);

    let audioElement = document.getElementById("audioPlayer");
    const audio = new Audio(audioUrl);
    audioElement.src = audioUrl;
    audioElement.play();
    dispatch(notify("success", "Please wait playing audio !"));
  } catch (err) {
    dispatch(notify("error", "Failed to play audio"));

    console.log(err, "error");
  }
};
// Update Collection

export const updateCollection = async (collection, dispatch) => {
  let _orgId = getCookie("org_id");
  var data = new FormData();
  data.append("collectionName", collection?.collectionName);
  data.append("description", collection?.description);
  data.append("model", collection?.model);
  data.append("response_language", collection?.response_language);
  data.append("url",collection.urls)
  data.append("password",collection.password)

  let token = await getKeycloackToken();
  var config = {
    method: "post",
    url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UpdateCollectionDetails`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
      "x-orgId": _orgId,
    },
    data: data,
  };

  try {
    let status = await axios(config);
    return status;
  } catch (err) {
    console.log("Error while updating collection", err.message);

    return err;
  }
};

export const thumbsAction = async (id, is_thumbs_up) => {
  try {
    let _orgId = getCookie("org_id");
    let token = await getKeycloackToken();

    let data = new FormData();
    data.append("id", id);
    data.append("is_thumbs_up", is_thumbs_up);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/UpdateThumbsUpView`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const uploadUrl = async (collectionName, url, resourceName) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("document", url);
    data.append("collectionName", collectionName);
    data.append("jsonData", "");
    data.append("documentName", resourceName);
    data.append("fileUrl", url);

    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v1_1/UploadDocument`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const updateSystemPrompt = async (collectionName, userName, promptText) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("new_prompt", promptText);
    data.append("partition_name", collectionName);
    data.append("username", userName);
   
    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/UpdateSystemPrompt`,
      method: 'post',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};

export const updatePreProcessingInstructions = async (collectionName, userName, preProcessText) => {
  try {
    let _orgId = getCookie("org_id");

    let token = await getKeycloackToken();
    let data = new FormData();
    data.append("preprocess_instruct", preProcessText);
    data.append("partition_name", collectionName);
    data.append("username", userName);
   
    var config = {
      url: `${process.env.REACT_APP_SUPER_KNOWLEDGE_BASE_URL}/app/v2/PreprocessInstruct`,
      method: 'post',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "x-orgId": _orgId,
      },
      data: data,
    };
    let result = await axios(config);
    return result?.data;
  } catch (e) {
    console.log("error", "Something went wrong");
  }
};
